import { useState } from "react";
import { API_BASE } from "../config";
import { plantelDeMatricula, idBDDesdePlantel } from "../utilities/plantel";
import { generarFolioTPV as generarFolio, descargarOrdenDePago } from "../utilities/ordenDePago";

export const usePagoVentanilla = (alumno) => {
  const [cargandoPdf, setCargandoPdf] = useState(false);

  // Utilidad interna para evitar repetir el cálculo del Plantel
  const obtenerIdPlantelBD = () => {
    return idBDDesdePlantel(plantelDeMatricula(alumno.codigo));
  };

  const generarFolioTPV = () => generarFolio(obtenerIdPlantelBD());

  const guardarIntencionBD = async (
    conceptosGrupo,
    importe,
    refBanorte,
    refBBVA,
    folioRegistro = null,
    metodoEsperado = "VENTANILLA",
    autorizacion = null
  ) => {
    const clavesConceptos = conceptosGrupo.map((item) => item.clave).join(", ");
    
    try {
      const response = await fetch(`${API_BASE}/wMultipagosGuardarIntencion.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          codigo_alumno: String(alumno.codigo),
          referencia_banorte: refBanorte,
          referencia_bbva: refBBVA || null,
          importe: importe,
          conceptos: conceptosGrupo,
          clave_concepto: clavesConceptos,
          id_plantel: obtenerIdPlantelBD(),
          metodo_esperado: metodoEsperado,
          folio_registro: folioRegistro,
          // numero de autorizacion de Banorte (solo pago en linea); el servidor lo exige para guardar ese pago
          autorizacion: autorizacion,
        }),
      });
      return response.ok;
    } catch (error) {
      console.error("Error al guardar intención en BD:", error);
      return false;
    }
  };

  const descargarPdf = async (tablaConceptos, folioRegistro, fechaVencimiento) => {
    setCargandoPdf(true);
    try {
      await descargarOrdenDePago(
        {
          name: alumno.nombre,
          code: alumno.codigo,
          table: tablaConceptos,
          folioRegistro,
          fechaVencimiento,
        },
        `Orden de pago_${alumno.codigo}.pdf`
      );
    } catch (error) {
      console.error("Error generando PDF:", error);
    } finally {
      setCargandoPdf(false);
    }
  };

  return {
    cargandoPdf,
    generarFolioTPV,
    guardarIntencionBD,
    descargarPdf,
  };
};